import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@icons/locationIcon.svg'


const _hoisted_1 = {
  class: "location-chip-zip",
  tabindex: "0"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  class: "mr-1 img-location-icon",
  src: _imports_0,
  alt: "location icon"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "|", -1)
const _hoisted_4 = {
  key: 0,
  id: "lblRadius",
  class: "location-chip-radius",
  tabindex: "0"
}
const _hoisted_5 = {
  key: 1,
  class: "location-chip-radius",
  tabindex: "0"
}
const _hoisted_6 = {
  key: 2,
  class: "location-chip-radius",
  tabindex: "0"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterChipItem = _resolveComponent("FilterChipItem")!
  const _component_StringData = _resolveComponent("StringData")!
  const _component_RangeData = _resolveComponent("RangeData")!
  const _component_ChevronDownIconBlue = _resolveComponent("ChevronDownIconBlue")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["filter-chip-container", { 'collapsed-container': !_ctx.isExpanded && _ctx.isMobile }]),
    ref: "divFilterChipContainer",
    style: _normalizeStyle(_ctx.cssVars)
  }, [
    _createVNode(_component_FilterChipItem, {
      id: "btnDistanceShipping",
      ref: "btnDistanceShipping",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setFilter('storename'))),
      class: "btn-distance-shipping button my-1",
      isCloseable: false
    }, {
      value: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("b", null, _toDisplayString(_ctx.zipCode), 1)
        ]),
        _hoisted_3,
        (!_ctx.shopByStore && _ctx.radius !== -1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.replaceText(_ctx.$t('Cars Within Miles'), ';xMiles;', _ctx.radius)), 1))
          : _createCommentVNode("", true),
        (!_ctx.shopByStore && _ctx.radius === -1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.$t('Nationwide')), 1))
          : _createCommentVNode("", true),
        (_ctx.shopByStore)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t('Distance Shipping Toggle Text Right')), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    (_ctx.shipToStore && _ctx.shipToStoreToggleFeatureFlag)
      ? (_openBlock(), _createBlock(_component_FilterChipItem, {
          key: 0,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilter('shiptostore'))),
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeShipToStore())),
          id: "btnShipToStore",
          class: "button filterButton nonDistanceShipButton my-1 flex-container",
          value: _ctx.$t('Ship to store')
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedStoreNames, (item) => {
      return (_openBlock(), _createBlock(_component_FilterChipItem, {
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setFilter('storename'))),
        onClose: ($event: any) => (_ctx.removeFromIncludedDealerships(item)),
        class: "button filterButton nonDistanceShipButton my-1 flex-container",
        value: item,
        key: item
      }, null, 8, ["onClose", "value"]))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedFacets, (item, facetType) => {
      return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredStringFacets(facetType, 'string', item), (value) => {
          return _withDirectives((_openBlock(), _createBlock(_component_FilterChipItem, {
            id: `btn${facetType}${value}`,
            onClick: ($event: any) => (_ctx.setFilter(facetType)),
            onClose: ($event: any) => (_ctx.closeStringFacet(facetType, value)),
            class: _normalizeClass(["button filterButton nonDistanceShipButton my-1 flex-container", { btnRemove: item.type != 'string' }]),
            "data-type": item.type,
            "data-should-hide": item.type != 'string',
            key: `btn${facetType}${value}`
          }, {
            value: _withCtx(() => [
              (_ctx.facetMetaData[facetType])
                ? (_openBlock(), _createBlock(_component_StringData, {
                    key: 0,
                    class: "btnText",
                    tabindex: "0",
                    item: value,
                    postfix: _ctx.facetMetaData[facetType].postfix,
                    "data-testid": "filter-chip-non-distance-ship-button-text"
                  }, null, 8, ["item", "postfix"]))
                : _createCommentVNode("", true)
            ]),
            _: 2
          }, 1032, ["id", "onClick", "onClose", "data-type", "data-should-hide", "class"])), [
            [_vShow, _ctx.showButton(`btn${facetType}${value}`) || _ctx.isExpanded]
          ])
        }), 128)),
        _withDirectives(_createVNode(_component_FilterChipItem, {
          id: `btn${facetType}`,
          class: _normalizeClass([{ btnRemove: item.type !== 'numericRange' }, "button filterButton nonDistanceShipButton my-1 flex-container"]),
          onClose: ($event: any) => (_ctx.closeNumericFacet(facetType)),
          onClick: ($event: any) => (_ctx.setFilter(facetType))
        }, {
          value: _withCtx(() => [
            (_ctx.facetMetaData[facetType])
              ? (_openBlock(), _createBlock(_component_RangeData, {
                  key: 0,
                  class: "btnText",
                  tabindex: "0",
                  max: 
              facetType === 'year'
                ? String(item?.max || 0)
                : String(Number(item?.max || 0).toLocaleString())
            ,
                  min: 
              facetType === 'year'
                ? String(item?.min || 0)
                : String(Number(item?.min || 0).toLocaleString())
            ,
                  prefix: _ctx.facetMetaData[facetType].prefix,
                  postfix: _ctx.facetMetaData[facetType].postfix,
                  "data-testid": "filter-chip-non-distance-ship-button-text"
                }, null, 8, ["max", "min", "prefix", "postfix"]))
              : _createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["id", "class", "onClose", "onClick"]), [
          [_vShow, item.type === 'numericRange' && (_ctx.showButton(`btn${facetType}`) || _ctx.isExpanded)]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredHierarchicalFacets(facetType, item), (value) => {
          return _withDirectives((_openBlock(), _createBlock(_component_FilterChipItem, {
            id: `btn${facetType}${value}`,
            onClose: ($event: any) => (_ctx.closeHierarchicalFacet(value)),
            onClick: ($event: any) => (_ctx.setFilter(facetType)),
            class: "button filterButton nonDistanceShipButton my-1 flex-container",
            value: value,
            key: `btn${facetType}${value}`
          }, null, 8, ["id", "onClose", "onClick", "value"])), [
            [_vShow, _ctx.showButton(`btn${facetType}${value}`) || _ctx.isExpanded]
          ])
        }), 128))
      ], 64))
    }), 256)),
    _withDirectives(_createVNode(_component_FilterChipItem, {
      id: "btnExpand",
      onClick: _ctx.expandButtons,
      class: _normalizeClass(["button flex-container expandButton mobile-only nonDistanceShipButton my-1", { 'show-less': _ctx.isExpanded }]),
      isCloseable: false
    }, {
      value: _withCtx(() => [
        _withDirectives(_createElementVNode("span", null, "+" + _toDisplayString(_ctx.hiddenChips), 513), [
          [_vShow, !_ctx.isExpanded]
        ]),
        _withDirectives(_createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('srp.common.showLess')) + " ", 1),
          _createVNode(_component_ChevronDownIconBlue)
        ], 512), [
          [_vShow, _ctx.isExpanded]
        ])
      ]),
      _: 1
    }, 8, ["onClick", "class"]), [
      [_vShow, _ctx.isMobile && _ctx.hiddenChips > 0]
    ])
  ], 6))
}